// Centralised API helper for lead-capture endpoints
const BASE = process.env.REACT_APP_BACKEND_URL;

const postJson = async (path, body) => {
  const res = await fetch(`${BASE}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`Submission failed (${res.status}): ${text}`);
  }
  return res.json();
};

export const submitQuiz = (data) => postJson("/api/leads/quiz", data);
export const submitEuQuiz = (data) => postJson("/api/leads/eu-quiz", data);
export const submitChecklist = (data) => postJson("/api/leads/checklist", data);
export const submitCalculator = (data) => postJson("/api/leads/calculator", data);
